import React, {PropTypes} from "react";
import LinearProgress from "material-ui/LinearProgress";

const Background = (props) => {

  return (<header style={{height: '300px'}}>
      <div className="jumbotron home-banner" style={{paddingTop: 0}}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h1 style={{marginTop: '5%'}} className="text-center">Welcome to Quikr hrms</h1>
              {props.loading > 0 ? <LinearProgress mode="indeterminate" style={{marginLeft: '10%', width: '80%'}}/> :
                <label></label> }
            </div>
          </div>
        </div>

      </div>
    </header>
  );

};

Background.proptypes = {};

export default Background;



/** WEBPACK FOOTER **
 ** ./src/components/common/Background.js
 **/